<template>
	<md-toolbar :class="[`md-${type}`]"
				:color-on-scroll="colorOnScroll"
				class="md-fixed"
				id="toolbar"
				md-elevation="0">


		<header>
			<div class="header-logo">
				<router-link class="" to="/">
					<img class="logotop" height="38" src="@/assets/images/logo_new.svg" width="180">
				</router-link>
			</div>

			<div class="header-right">

				<md-button @click="show_menu" class="md-just-icon md-simple md-toolbar-toggle">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>

				<div class="md-layout">
					<div class="md-layout-item">
						<md-button class="header-lk md-primary" @click="logoutUser">Выход</md-button>
					</div>
				</div>
				<div class="md-toolbar-row md-collapse-lateral mainmenu">
					<div class="md-toolbar-section-start"></div>
					<div class="md-toolbar-section-center"></div>
				</div>
			</div>

			<div class="mobile-menu md-elevation-5">
				<div class="mobile-menu__logo">
					<router-link :to="{ name: 'index' }">
						<img class="logotop" src="@/assets/images/logo_new.svg">

					</router-link>
				</div>
				<md-button class="header-lk md-primary" @click="logoutUser">Выход</md-button>
			</div>
		</header>
	</md-toolbar>
</template>

<script>
	import {logout} from '../utils/auth-api'

    export default {
        props: {
            type: {
                type: String,
                default: 'white',
                validator (value) {
                    return [
                        'white',
                        'default',
                        'primary',
                        'danger',
                        'success',
                        'warning',
                        'info',
                        'dark',
                    ].includes(value)
                },
            },
            colorOnScroll: {
                type: Number,
                default: 0,
            },
            navbarTransparent: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                extraNavClasses: '',
                toggledClass: false,
            }
        },
        computed: {},
        methods: {
            logoutUser () {
                logout('/')
			},
            show_menu () {
                document.querySelector('.mobile-menu').classList.toggle('mobile-menu--active')
            },
            show_tooltip () {
                document.querySelector('.header-logo').classList.add('header-logo--active')
            },
            hide_tooltip () {
                document.querySelector('.header-logo').classList.remove('header-logo--active')
            },
            bodyClick () {
                let bodyClick = document.getElementById('bodyClick')

                if (bodyClick === null) {
                    let body = document.querySelector('body')
                    let elem = document.createElement('div')
                    elem.setAttribute('id', 'bodyClick')
                    body.appendChild(elem)

                    let bodyClick = document.getElementById('bodyClick')
                    bodyClick.addEventListener('click', this.toggleNavbarMobile)
                } else {
                    bodyClick.remove()
                }
            },
            toggleNavbarMobile () {
                this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar
                this.toggledClass = !this.toggledClass
                this.bodyClick()
            },
            handleScrollMenu () {
                var menu = document.querySelector('header')

                if (menu.classList.contains('menu-fixed') && window.pageYOffset < 200) {
                    menu.classList.remove('menu-fixed')
                } else if (window.pageYOffset > 200) {
                    menu.classList.add('menu-fixed')
                }
            },
            scrollListener () {
                this.handleScrollMenu()
            },
        },
        mounted () {
            document.addEventListener('scroll', this.scrollListener)
        },
        beforeDestroy () {
            document.removeEventListener('scroll', this.scrollListener)
        },
    }
</script>
<style lang="scss">
</style>
